module.exports = __webpack_public_path__ + "static/media/no_buildings_90px.925d4ee0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no_photo/no_buildings_90px.png
// module id = 1610
// module chunks = 0